import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useSubstructureLayout } from "./useSubstructureLayout";
/**
 * Position add button before or after instances
 * @param props
 * @returns
 */
export function SubstructureElementLayout(props) {
    const { elementOrder } = useSubstructureLayout();
    const { addButton, instanceList } = props;
    const elements = {
        AddButton: addButton,
        InstanceList: instanceList,
    };
    return (_jsx(Fragment, { children: elementOrder === null || elementOrder === void 0 ? void 0 : elementOrder.map((element, elementIndex) => (_jsx(Fragment, { children: elements[element] }, elementIndex))) }));
}
//# sourceMappingURL=SubstructureElementLayout.js.map